import type { ReactNode } from "react";
import { Button } from "@/components/ui/button";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "@/components/ui/popover";

/**
 * The "+N more" row under a collapsible nav group's inline sub-items. Opens a
 * side popover listing the rest — the children are the overflow rows, already
 * wrapped the same way the inline ones are. Shared by Campaigns / Ask Amy /
 * Settings so the three groups truncate identically.
 */
export function NavMorePopover({
  count,
  children,
}: {
  count: number;
  children: ReactNode;
}) {
  if (count <= 0) return null;
  return (
    <div className="w-full flex justify-start pr-4 mt-2 mb-2 ml-4">
      <Popover>
        <PopoverTrigger asChild>
          <Button
            variant="muted-ghost"
            size="sm"
            className="text-xs h-7 px-2 font-normal rounded-sm data-[state=open]:text-foreground"
          >
            +{count} more
          </Button>
        </PopoverTrigger>
        <PopoverContent
          side="right"
          align="start"
          className="w-56 flex flex-col gap-1 p-2 rounded-xl max-h-96.5 overflow-auto bg-sidebar [scrollbar-color:--alpha(var(--foreground)/30%)_transparent] scrollbar-thin"
          sideOffset={8}
        >
          {children}
        </PopoverContent>
      </Popover>
    </div>
  );
}
